import React from "react";
import PublicIcon from "@mui/icons-material/Public";
import FormValidation from "../../components/FormValidation/FormValidation";
import formFields from "../../config/formFields.json";

const AddCountry = ({ open, onClose, initialData = null, onSubmit }) => {
  const isEdit = !!initialData;

  const initialValues = {
    country_name: initialData?.country_name || "",
    country_code: initialData?.country_code || "",
    short_name: initialData?.short_name || "",
    is_active: initialData?.is_active ?? true,
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.country.basic.fields}
      title="Country"
      icon={PublicIcon}
      isEdit={isEdit}
      modelWidth="40vw"
    />
  );
};

export default AddCountry;
